import DZModelPage from "@/model/DZModelPage";

class DZSearchDemand extends DZModelPage{

    /**
     * 区域ID
     */
    county = "";

    countyArr = [];

    /**
     * 区域等级
     */
    level = "";
    /**
     * 流转类型ID
     */
    moverType = "";

    /**
     * 发布时间（时间戳）
     */
    releaseTime = "";

    status;

}
export default DZSearchDemand
